import React from 'react';
import log from 'loglevel';
import { MaybeCognitoError } from '@move-frontend/auth';
import { ApiErrorMessage } from '../../../errors/ApiErrorMessage';

interface IErrorProps {
	error: MaybeCognitoError;
}

export const SaveDetailsError = ({ error }: IErrorProps) => {
	log.info('SaveDetailsError:', error);

	return (
		<ApiErrorMessage
			error={error}
			genericMessage="parking_personal_details_generic_error"
		/>
	);
};
